import React, { Fragment, useContext, useMemo, useState } from "react";
import { Breadcrumb } from "react-bootstrap";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { AppContext } from "../../context/AppContext";
import Utils from "../../utils/Utils";
import ReservationScheduler from "./scheduler/ReservationScheduler";
import { withIds } from "./scheduler/Utilities";
import ReservationSchedulerNew from "./scheduler2/ReservationSchedulerNew";

const localizer = momentLocalizer(moment);

function ReservationCalendar() {
  const { enquiriesHistory, recentEnquiries, reservationSettings } =
    useContext(AppContext);
  const [showDetails, setShowDetails] = useState(true);
  const [selectedDate, setSelectedDate] = useState(null);

  const [reservDetails, setReservDetails] = useState({
    userID: "",
    name: "",
    email: "",
    phone: "",
    bookingDate: "",
    bookingTime: "",
    formattedID: "",
    status: "",
    chairs: 0,
    message: "",
  });
  const [date, setDate] = useState(new Date());

  const enquiriesData = useMemo(() => {
    const list = recentEnquiries?.enquiries || [];
    const statusArray = list?.statuses || list?.statusList || [];

    const resolveStatus = (enquiry) => {
      if (typeof enquiry?.status === "string" && enquiry.status.trim())
        return enquiry.status;

      const id = enquiry?.statusId ?? enquiry?.status_id;
      if (typeof id === "number" && statusArray[id]) return statusArray[id];

      return "";
    };

    return list.map((enquiry) => {
      const start = moment(
        enquiry?.bookingTime,
        "YYYY-MM-DD HH:mm:ss",
        true
      ).toDate();
      const end = new Date(start.getTime() + 60 * 60 * 1000);

      const title = `${enquiry?.chairs} chairs (${enquiry?.name ?? ""})`;

      return {
        ...enquiry,
        title,
        start,
        end,
        // status: resolveStatus(enquiry),
      };
    });
  }, [recentEnquiries]);

  const getStatusColor = (event) => {
    let backgroundColor = "#2563eb";
    let color = "white";

    switch (event.status) {
      case "Cancelled":
        backgroundColor = "#dc2626";
        break;
      case "Rejected":
        backgroundColor = "#6b7280";
        break;
      case "Approved":
        backgroundColor = "#16a34a";
        break;
      case "Seated":
        backgroundColor = "#2563eb";
        break;
      case "Requested":
        backgroundColor = "#fef3c7";
        color = "#92402c";
        break;
      default:
        backgroundColor = "#374151";
    }

    return { backgroundColor, color };
  };

  const isToday = useMemo(
    (event) => {
      if (!enquiriesData) return "month";

      const isToday = enquiriesData.find((x) => {});
    },
    [enquiriesData]
  );

  const [bookings, setBookings] = useState(() =>
    withIds([
      {
        tableId: 1,
        date,
        start: 18 * 60,
        end: 19 * 60 + 30,
        name: "A. Smith",
        chairs: 4,
        colour: "#10b981",
      },
    ])
  );

  const tables = 10;

  return (
    <Fragment>
      {/* <Breadcrumb pageTitle="Reservations" title="Reservation List" /> */}
      <div className="reservation-calendar-shell">
        {/* <ReservationScheduler
          date={date}
          onDateChange={setDate}
          startHour={8}
          endHour={23}
          slotMinutes={15}
          tables={tables}
          bookings={bookings}
          onCreateBooking={(bk) => setBookings((prev) => [...prev, bk])}
          onUpdateBooking={(bk) =>
            setBookings((prev) => prev.map((x) => (x.id === bk.id ? bk : x)))
          }
          onDeleteBooking={(id) =>
            setBookings((prev) => prev.filter((x) => x.id !== id))
          }
        /> */}
        <ReservationSchedulerNew
          disabledHours={[0, "02:00-03:30", { from: "12:00", to: "13:00" }]}
        />
      </div>
    </Fragment>
  );
}

export default ReservationCalendar;
